// api/notificationApi.js
import axios from 'axios';

const API_BASE = 'https://hms.backend.hiragroupcloud.com';

const authHeaders = () => {
  const token = localStorage.getItem('accessToken');
  return token ? { Authorization: `Bearer ${token}` } : {};
};

export const fetchNotifications = async ({ unreadOnly = false, limit = 100 } = {}) => {
  const params = { limit };
  if (unreadOnly) params.unreadOnly = 1;
  const res = await axios.get(`${API_BASE}/api/notifications`, {
    headers: authHeaders(),
    params
  });
  return res.data;
};

export const fetchUnreadCount = async () => {
  const res = await axios.get(`${API_BASE}/api/notifications/unread-count`, {
    headers: authHeaders()
  });
  return res.data;
};

export const markAsRead = async (id) => {
  const res = await axios.put(
    `${API_BASE}/api/notifications/${id}/read`,
    {},
    { headers: authHeaders() }
  );
  return res.data;
};

export const fetchMyMentions = async () => {
  const res = await axios.get(`${API_BASE}/api/mentions`, {
    headers: authHeaders()
  });
  return res.data;
};
// NEW: react to a note (toggle / change emoji)
export const reactToNote = async (caseId, noteId, emoji) => {
  const res = await axios.put(
    `${API_BASE}/api/cases/${caseId}/notes/${noteId}/react`,
    { emoji },
    { headers: authHeaders() }
  );
  return res.data;
};